let store = require("../store");
let actions = require("../actions");

let { IconButton, Drop, Check } = mc.widgets;
let { Legend } = mc.charts;
let { Plot, XAxis, YAxis, Line, Area, Scatter } = mc.plot;
let { NAVY, TURQUOISE, PINK } = mc.ui.colors;

let MetricUtil = require("../util/MetricUtil");

class MetricListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { subjectId } = this.props;
    let { subjects, metrics, prefs } = store.getState();

    return {
      subject: subjects[subjectId],
      metrics: metrics[subjectId],
      prefs
    };
  }

  componentDidMount() {
    let { studyId, subjectId } = this.props;

    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadSubject(studyId, subjectId);
    actions.loadMetrics(studyId, subjectId);

    mc.ui.on("resize", this.onResize.bind(this));

    this.onResize();
  }

  componentWillUnmount() {
    this.unsubscribe();

    mc.ui.off("resize");
  }

  onResize() {
    let node = ReactDOM.findDOMNode(this);
    let pageWidth = node.parentNode.getBoundingClientRect().width - 50;

    this.setState({ pageWidth });
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  selectDate(startTs) {
    let { studyId, subjectId } = this.props;

    mc.router.trigger("METRIC_DETAIL_VIEW", { studyId, subjectId, startTs });
  }

  help() {
    mc.ui.help(`./help/${rc.lang}/analytics_summary.html`);
  }

  toggleCompactLayout(checked) {
    actions.setPref("METRIC_LIST_COMPACT_LAYOUT", checked);
  }

  toggleSmoothSpline(checked) {
    actions.setPref("METRIC_LIST_SMOOTH_SPLINE", checked);
  }

  toggleFill(checked) {
    actions.setPref("METRIC_LIST_SHOW_FILL", checked);
  }

  toggleTrendLine(checked) {
    actions.setPref("METRIC_LIST_SHOW_TREND", checked);
  }

  toggleMedianLine(checked) {
    actions.setPref("METRIC_LIST_SHOW_MEDIAN", checked);
  }

  render() {
    let {
      subject = {},
      metrics = [],
      prefs,
      pageWidth = 800
    } = this.state;

    let isCompact = prefs.METRIC_LIST_COMPACT_LAYOUT === true && pageWidth >= 800;
    let isSmooth = prefs.METRIC_LIST_SMOOTH_SPLINE === true;
    let showTrend = prefs.METRIC_LIST_SHOW_TREND === true;
    let showMedian = prefs.METRIC_LIST_SHOW_MEDIAN === true;
    let showFill = prefs.METRIC_LIST_SHOW_FILL === true;

    let legend = [
      {
        label: tx("actual"),
        color: NAVY,
        bullet: Legend.SPLINE
      }
    ];

    if (showTrend) {
      legend.push({
        label: tx("trend"),
        color: TURQUOISE,
        bullet: Legend.DASHED_LINE
      });
    }

    if (showMedian) {
      legend.push({
        label: tx("median"),
        color: PINK,
        bullet: Legend.LINE
      });
    }

    return (
      <div className="rc-metric-list-view" data-hidden={subject.isHidden}>
        <div className="mc-split-layout">
          <h1>
            <a href={mc.router.resolve("SUBJECT_DETAIL_VIEW", this.props)}>
              {subject.displayName || "..."}
            </a>
            {" › " + tx("analytics")}
          </h1>
          <div>
            <IconButton icon="help" onPress={this.help}/>
            <Drop align="right">
              <IconButton icon="configure" scale={1.2}/>
              <ul className="mc-drop-content">
                <li>
                  <Check
                    size="small"
                    shape="square"
                    label={tx("compact_layout")}
                    checked={isCompact}
                    onCheck={this.toggleCompactLayout.bind(this)}/>
                </li>
                <li>
                  <Check
                    size="small"
                    shape="square"
                    label={tx("smooth_spline")}
                    checked={isSmooth}
                    onCheck={this.toggleSmoothSpline.bind(this)}/>
                </li>
                <li>
                  <Check
                    size="small"
                    shape="square"
                    label={tx("show_fill")}
                    checked={showFill}
                    onCheck={this.toggleFill.bind(this)}/>
                </li>
                <li>
                  <Check
                    size="small"
                    shape="square"
                    label={tx("show_trend_line")}
                    checked={showTrend}
                    onCheck={this.toggleTrendLine.bind(this)}/>
                </li>
                <li>
                  <Check
                    size="small"
                    shape="square"
                    label={tx("show_median_line")}
                    checked={showMedian}
                    onCheck={this.toggleMedianLine.bind(this)}/>
                </li>
              </ul>
            </Drop>
          </div>
        </div>

        {legend.length > 1 ? (
          <Legend items={legend}/>
        ) : null}

        {["SLEEPING", "RESTING", "MOVING"].map((type) => {
          let keys = MetricUtil.METRICS.filter((m) => m.match(type));

          return (
            <section key={type} data-display-compact={isCompact}>
              <h2 data-type={type}>{tx(type)}</h2>
              <div>
                {keys.map((key) => {
                  let data = metrics;
                  let getX = (d) => d.dayStartMsUtc;
                  let getY = (d) => {
                    let y = d.metrics[key];
                    return key.match(/DURATION$/) ? y / 3600 : y;
                  };
                  let median = mc.math.median(data, getY) || 0;
                  let trendY = mc.plot.trend(data, getX, getY);
                  let formatX = (x) => {
                    return x % mc.math.MILLIS_PER_DAY === 0 ? mc.format.date(x, "GMT", "compact") : "";
                  };

                  return (
                    <div key={key} data-metric={key}>
                      <h3>{tx(key)}</h3>
                      <Plot
                        width={isCompact ? (pageWidth / 2) - 30 : pageWidth}
                        height={210}
                        data={data}
                        getX={getX}
                        getY={getY}
                        formatX={formatX}
                        insetX={20}
                        typeX="UTC">
                          <XAxis label={tx("date")}/>
                          <YAxis label={tx("axis." + MetricUtil.UNITS[key])}/>
                          <Line color={TURQUOISE} stroke={1.5} dash="6 4" dot={null} getY={trendY} visible={showTrend}/>
                          <Line color={PINK} stroke={1.5} getY={() => median} dot={null} visible={showMedian}/>
                          <Area color={NAVY} opacity={0.1} shape={isSmooth ? "curve" : "line"} visible={showFill}/>
                          <Line color={NAVY} shape={isSmooth ? "curve" : "line"}/>
                          <Scatter image="./img/rc/bang.svg" size={12} getY={(d) => (d.errorTypes.length ? 0 : null)}/>
                          <XAxis.Nav onClick={this.selectDate.bind(this)} filter={false}/>
                      </Plot>
                    </div>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    );
  }
}

module.exports = MetricListView;